import { openInNewTab } from './open-in-new-tab';
export const goToWorkbench = () => {
  openInNewTab({
    url: 'https://co.wps.cn/workbench/?vcl=v2#/office_8880?from=servicecenter&secondSrc=wps_app',
    appid: 'kservicecounter',
    src: 'wps_app',
  });
};
